import React from 'react'
import { defer, LoaderFunction, Outlet } from 'react-router-dom'
import { store } from '../../redux/store'
// import MpHeader from '../shared/organism/MpHeader'
import { fetchCode} from '../../redux/corporateService'
import { getCorporateProfile } from '../../redux/CorporateProfile/CorporateProfileSlice'

export const mainLayoutLoader: LoaderFunction = async () => {
  const corporateProfile = store.dispatch(getCorporateProfile()).unwrap()
  const corporateCode = store.dispatch(fetchCode()).unwrap()
  return defer({ corporateProfile, corporateCode })
}

export const MainLayout = () => {
  return (
    <>
      {/* <MpHeader /> */}
      <Outlet />
    </>
  )
}